import { Pipe, PipeTransform } from "@angular/core";
import { FileLogger } from "@comunicare/comunicare-helper";
import { IIdentity, IPatient } from "@comunicare/comunicare-interfaces";

@Pipe({ name: "getLatestIdentityFromPatient" })
export class GetLatestIdentityFromPatientPipe implements PipeTransform {
  transform(patient: IPatient): IIdentity {
    const latestIdentity = patient.identity[patient.identity.length - 1];
    if (!latestIdentity.period?.end) {
      return latestIdentity;
    } else {
      FileLogger.error("GetLatestIdentityFromPatientPipe", "Cannot find latest identity");
    }
  }
}
